import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios'; // Make sure to import axios
import store from "../store/index";

// Import your views
import Home from '../views/Home.vue';
import Errors from '../views/Errors.vue';
import Page from '../views/Page.vue';
import Contact from '../views/Contact.vue';
import Press from '../views/Press.vue';
import Journals from '../views/Journals.vue';
import JournalArticle from '../views/JournalArticle.vue';
import WatchesRandomComponent from '../views/WatchesRandom.vue';
import WatchesOrderedComponent from '../views/WatchesOrdered.vue';
import OtherWatchesRandom from '../views/OtherWatchesRandom.vue';
import RMWatchCard from '../views/RMWatchCard.vue';
import OtherWatchCard from '../views/OtherWatchCard.vue';
import WatchModel from '../views/WatchModel.vue'

import MembershipFeaturedWatches from '../views/MembershipFeaturedWatches.vue';
import JewelriesRandom from '../views/JewelriesRandom.vue';
import JewelleryCard from '../views/JewelleryCard.vue';
// import Membership from '../views/Membership.vue';
import Login from '../views/Login.vue';
import Dashboard from '../views/Dashboard.vue';
import User from '../views/User.vue';
import Register from '../views/Register.vue';
import PasswordReset from '../components/PasswordReset.vue';
import PasswordForgot from '../components/PasswordForgot.vue';
// Define the route guard function
const checkAndRedirect = async (to, from, next) => {
  try {
    const response = await axios.get('/api/websiteitems');
    
    if (response.status === 200) {
      const websiteItems = response.data.data;
      const routeNameWithSlash = `/${to.name}`; // Prepend '/' to the route name

      const matchingItem = websiteItems.find(item => {
        return item.router_link === routeNameWithSlash && item.status === 1;
      });

      if (matchingItem) {
        next('/404');
      } else {
        next();
      }
    } else {
      console.error('Failed to fetch website items data');
      next();
    }
  } catch (error) {
    console.error('An error occurred:', error);
    next();
  }
};

const routes = [
  {
    path: '/',
    name: 'home',
    meta: { 
        title: 'Haute Horologie'
    },
    component: Home,
    /* props: true, */
  },
    {
    path: '/about',
    name: 'about',
    meta: { 
        title: 'About'
      },
      component: Page,
  },
  {
    path: '/contact',
    name: 'contact',
    meta: {
      title: 'Contact'
    },
    component: Contact,
  },
     {
        path: '/locations',
        name: 'locations',
        meta: { 
            title: 'Locations'
        },
        component: Page,
        // beforeEnter: checkAndRedirect,
  },
    {
      path: '/sellyourwatch',
      name: 'sellyourwatch',
      meta: { 
          title: 'sellyourwatch'
      },
      component: Page,
      // beforeEnter: checkAndRedirect,
  },
    {
      path: '/legal',
      name: 'legal',
      component: Page,
      // beforeEnter: checkAndRedirect,
  },

  {
    path: '/richard-mille-watches',
    name: 'rm-watches',
    meta: { 
      title: 'Richard Mille'
    },
    component: WatchesRandomComponent,
    props: true,
    // beforeEnter: checkAndRedirect,
  },
  {
    path: '/watchmodel/:watchModel',
    name: 'watchModel',
    meta: { 
      title: 'Watch Model'
    },
    component: WatchModel,
    props: true,
  },
  {
    path: '/richard-mille-watch/:watchModel/:watchSKU',
    name: 'rmwatch',
    meta: { 
        title: 'Watch details',
    },
    component: RMWatchCard,
  },
  {
    path: '/the-collection',
    name: 'the-collection',
        meta: { 
        title: 'All Brands'
    },
    component: OtherWatchesRandom,
    props: true,
    // beforeEnter: checkAndRedirect,
  },
    {
    path: '/watch/:watchManufacturerName-:watchModel/:watchSKU',
    name: 'otherwatch',
    meta: { 
        title: 'Watch Details',
    },
    component: OtherWatchCard,
  },
  {
    path: '/jewellery-catalogue',
    name: 'jewellery-catalogue',
    meta: { 
        title: 'Jewellery Catalogue'
    },
    component: JewelriesRandom,
    // beforeEnter: checkAndRedirect,
  },
  {
    path: '/jewellery/:jewellerySKU',
    name: 'jewellerycard',
    meta: { 
        title: 'Jewellery Card',
        props: true,
    },
    component: JewelleryCard,
    // beforeEnter: checkAndRedirect,
  },
  {
    path: '/Services',
    name: 'services',
    meta: { 
        title: 'Services'
    },
    component: Page,
    // beforeEnter: checkAndRedirect,
  },
    {
    path: '/New-Arrivals',
    name: 'new-arrivals',
    meta: { 
        title: 'New Arrivals'
    },
    component: WatchesOrderedComponent,
    // beforeEnter: checkAndRedirect,
  },
    {
    path: '/featuredwatches',
    name: 'featuredwatches',
    meta: { 
        title: 'Members Featured Watches',
        requiresAuth: true,
    },
    component: MembershipFeaturedWatches,

  },
  {
    path: '/journal',
    name: 'journal',
    component: Journals,
    // beforeEnter: checkAndRedirect,
  },
  {
    path: '/journal/:slug',
    name: 'journalarticle',
    component: JournalArticle,
    // beforeEnter: checkAndRedirect,
  },
  {
    path: '/press',
    name: 'press',
    component: Press,
    // beforeEnter: checkAndRedirect,
  },
/* USER BASED EXPARINCE AND CMS */
  {
    path: '/membership',
    name: 'membership',
        meta: { 
        title: 'Membership Area'
    },
    component: Login,
  },
  
  {
    path: "/login",
    name: "login",
    component: Login,
  }, 

  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: Page,
    /* props: true, */
  },
  {
    path: '/cookie-policy',
    name: 'cookie-policy',
    component: Page,
  },
  {
    path: '/terms-and-conditions',
    name: 'terms-and-conditions',
    component: Page,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    meta: { requiresAuth: true },
    component: Dashboard, // Use the imported component directly
  },
  {
    path: "/user",
    name: "user",
    meta: { requiresAuth: true },
    component: User,
  },

  {
    path: "/register",
    name: "register",
    component: Register,
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: PasswordReset,
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: PasswordForgot,
  },
  {
  path: '/404',
  name: '404',
  component: Errors,
 },
];

// Create the router instance
const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }; // Scroll to top of the page
  }
});

// Global before guard for authentication and redirection
router.beforeEach(async (to, from, next) => {
  const authUser = store.getters["auth/authUser"];
  const reqAuth = to.matched.some((record) => record.meta.requiresAuth);
  const loginQuery = { path: "/login", query: { redirect: to.fullPath } };

  if (reqAuth && !authUser) {
    await store.dispatch("auth/getAuthUser");
    if (!store.getters["auth/authUser"]) {
      next(loginQuery);
    } else {
      next();
    }
  } else {
    next(); // Ensure to always call next()!
  }
});

// Use the checkAndRedirect function as a route guard
router.beforeEach(checkAndRedirect);

export default router;